module.exports = __webpack_public_path__ + "img/1434863731.8932e912.jpg";